import { render, staticRenderFns } from "./PasswordSignupStep.vue?vue&type=template&id=31b0fa16&"
import script from "./PasswordSignupStep.vue?vue&type=script&lang=ts&"
export * from "./PasswordSignupStep.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordSignupStep.vue?vue&type=style&index=0&id=31b0fa16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports